export const uploadFile = (file) => ({
  method: "POST",
  endpoint: `/files`,
  headers: {
    "Content-Type": "application/json",
  },
  body: file,
});

export const uploadFileV2 = (file, onUploadProgress, headers = {}) => {
  const body = new FormData();
  body.append("file", file);
  return {
    endpoint: "/uploads",
    method: "POST",
    body,
    prefix: " ",
    headers: {
      "Content-Type": "multipart/form-data",
      ...headers,
    },
    onUploadProgress,
  };
};

export const uploadFormFile = (
  formId,
  file,
  onUploadProgress,
  headers = {}
) => {
  const body = new FormData();
  body.append("file", file);
  return {
    endpoint: `/forms/${formId}/uploads`,
    method: "POST",
    body,
    prefix: " ",
    headers: {
      "Content-Type": "multipart/form-data",
      ...headers,
    },
    onUploadProgress,
  };
};
